const imageOptions =
{
    maxHeight : 2000 ,
    maxWidth  : 2000 ,
    resize    : true
} ;

export default imageOptions ;